import React, { forwardRef } from "react"
import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import getCustomConfig from "src/utils/customDomains"

const Page = forwardRef(({ children, title = "", ...rest }, ref) => {
  const domain = window.location.hostname
  const config = getCustomConfig(domain)

  return (
    <div ref={ref} className="mt-3" {...rest}>
      <Helmet>
        {config.icon ? (
          <link
            rel="icon"
            href={`${config.icon}?v=${new Date().getTime()}`}
            data-react-helmet="true"
          />
        ) : null}
        <title>{title ? `${title} - ${config.title}` : config.title}</title>
      </Helmet>
      {children}
    </div>
  )
})

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
}

Page.defaultProps = {
  title: "",
}

export default Page
